import "./update.scss";
import { useUpdateProfile } from "./hooks/useUpdateProfile";
import ImageUploadSection from "./components/ImageUploadSection";
import UpdateFormFields from "./components/UpdateFormFields";

const Update = ({ setOpenUpdate, user }) => {
    const { formState, actions, isUpdating } = useUpdateProfile(user, setOpenUpdate);

    return (
        <div className="update">
            <div className="wrapper">
                <h1>
                  Update Your Profile
                </h1>

                <form>
                    <ImageUploadSection 
                        user={user}
                        coverFile={formState.coverFile}
                        setCoverFile={actions.setCoverFile}
                        profileFile={formState.profileFile}
                        setProfileFile={actions.setProfileFile}
                    />

                    <UpdateFormFields 
                        texts={formState.texts}
                        handleChange={actions.handleChange}
                    />

                    <button onClick={actions.handleSubmit} disabled={isUpdating}>
                        {isUpdating ? "Updating..." : "Update"}
                    </button>
                </form>

                <button className="close" onClick={() => setOpenUpdate(false)}>
                    X
                </button>
            </div>
        </div>
    );
};

export default Update;